import { type Experiment } from 'src/api/voisino/experiments.model'

export const FETCH_EXPERIMENTS = 'voisino/FETCH_EXPERIMENTS'
export const SET_EXPERIMENTS = 'voisino/SET_EXPERIMENTS'
export const SET_LOADING = 'voisino/SET_LOADING'
export const SET_ERROR = 'voisino/SET_ERROR'
export const CREATE_EXPERIMENT = 'voisino/CREATE_EXPERIMENT'
export const UPDATE_TEST_OUTCOME = 'voisino/UPDATE_TEST_OUTCOME'
export const ADD_EXPERIMENT = 'voisino/ADD_EXPERIMENT'
export const UPDATE_TEST_IN_STORE = 'voisino/UPDATE_TEST_IN_STORE'

export interface VoisinoExperimentsState {
    experiments: Experiment[]
    loading: boolean
    error: string | null
}

export type FetchExperiments = { type: typeof FETCH_EXPERIMENTS }
export type SetExperiments = { type: typeof SET_EXPERIMENTS; payload: Experiment[] }
export type SetLoading = { type: typeof SET_LOADING; payload: boolean }
export type SetError = { type: typeof SET_ERROR; payload: string | null }
export type CreateExperiment = { type: typeof CREATE_EXPERIMENT; payload: Experiment }
export type AddExperiment = { type: typeof ADD_EXPERIMENT; payload: Experiment }
export type UpdateTestOutcome = {
    type: typeof UPDATE_TEST_OUTCOME
    payload: { id: string; outcome: string; endDate?: string; lifecycleState?: string }
}
export type UpdateTestInStore = { type: typeof UPDATE_TEST_IN_STORE; payload: Experiment }
